<div>
  <div class="head-section">
    <h6 class="header-text text-white">MDA Bill Details</h6>
    <svg
      class="pointer"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      (click)="close()"
    >
      <g clip-path="url(#clip0_3558_32756)">
        <path
          d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345"
          stroke="#F00000"
          stroke-width="2.16781"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3558_32756">
          <rect
            width="17.3425"
            height="17.3425"
            fill="white"
            transform="translate(0.806641 0.748047)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="body-section">
    <div class="row justify-content-center mb-4">
      <div class="col-md-12">
        <div class="w-100">
          <div
            class="my-3 fw-700"
            style="
              position: relative;
              border: 1px solid #ccc;
              border-radius: 10px;
              background: #fff;
            "
          >
            <b
              style="
                position: absolute;
                background: #fff;
                padding: 0 10px;
                top: -12px;
                left: 20px;
              "
            ></b>
            <table
              class="table table-striped table-hover table-bordered split-table mt-3"
            >
              <tr>
                <th class="data-th">Invoice Number:</th>
                <td class="data-td" data-label="Invoice Number">
                  {{ billDetails?.invoiceNumber }}
                </td>
              </tr>

              <tr>
                <th class="data-th">MDA Name:</th>
                <td class="data-td" data-label="MDA Name">
                  {{ billDetails?.mdaName }}
                </td>
              </tr>

              <tr>
                <th class="data-th">ASIN:</th>
                <td class="data-td" data-label="ASIN">
                  {{ billDetails?.taxpayerAsin }}
                </td>
              </tr>

              <tr>
                <th class="data-th">Revenue Code:</th>
                <td class="data-td" data-label="Revenue Code">
                  {{ billDetails?.revenueCode }}
                </td>
              </tr>
              <tr>
                <th class="data-th">Rate Type:</th>
                <td class="data-td" data-label="Rate Type">
                  {{ billDetails?.serviceType }}
                </td>
              </tr>

              <tr *ngIf="billDetails?.customServiceName">
                <th class="data-th">Custom Service Name:</th>
                <td class="data-td" data-label="Custom Service Name">
                  {{ billDetails?.customServiceName }}
                </td>
              </tr>

              <tr *ngIf="billDetails?.customServiceType">
                <th class="data-th">Custom Service Type:</th>
                <td class="data-td" data-label="Custom Service Type">
                  {{ billDetails?.customServiceType }}
                </td>
              </tr>

              <tr *ngIf="billDetails?.customServiceDescription">
                <th class="data-th">Custom Description:</th>
                <td class="data-td" data-label="Custom Description">
                  {{ billDetails?.customServiceDescription }}
                </td>
              </tr>

              <tr>
                <th class="data-th">Payment Status:</th>
                <td class="data-td" data-label="Payment Status">
                  {{ billDetails?.paymentStatus }}
                </td>
              </tr>

              <tr>
                <th class="data-th">Taxpayer Name:</th>
                <td class="data-td" data-label="Taxpayer Name">
                  {{ billDetails?.taxpayerDisplayName }}
                </td>
              </tr>
              <tr>
                <th class="data-th">Transaction Amount:</th>
                <td class="data-td" data-label="Transaction Amount">
                  {{ currencySymbol
                  }}{{ billDetails?.transactionAmount | amount }}
                </td>
              </tr>
              <tr>
                <th class="data-th">Transaction Description:</th>
                <td class="data-td" data-label="Transaction Description">
                  {{ billDetails?.transactionDescription }}
                </td>
              </tr>
              <tr>
                <th class="data-th">Created By:</th>
                <td class="data-td" data-label="Created By">
                  {{ billDetails?.createdByName }}
                </td>
              </tr>
              <tr>
                <th class="data-th">Date Created:</th>
                <td class="data-td" data-label="Date Created">
                  {{ billDetails?.timeCreated | date }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
